import React from 'react'
import { hexColors } from '@mobi/settings/hexColors'
import { Icon } from '@mobi/component-library/Common/Icon'
import { SearchMessageDisplayStyled } from './InitialDisplay.styles'
import { SearchTextLabel } from '../SearchTextLabel/SearchTextLabel'
import {
  SearchTextLabelFontSize,
  SearchTextLabelLinkStyled,
} from '../SearchTextLabel/SearchTextLabelStyled.styles'
import { StructuredSearchRoute } from '@core/Areas/StructuredSearch/constants'
import { OverlayClose } from '@core/Components/Overlay'

export const InitialDisplay = () => {
  return (
    <SearchMessageDisplayStyled data-tid-search-upcoming-races>
      <Icon size='6rem' type='allraces' color={hexColors.darkGrey} />
      <SearchTextLabel size={SearchTextLabelFontSize.Medium}>
        Search for upcoming races...
      </SearchTextLabel>

      <SearchTextLabelLinkStyled
        id='advanced-search-link'
        size={SearchTextLabelFontSize.Small}
        to={`/${StructuredSearchRoute}`}
        onClick={() => OverlayClose()}
      >
        Advanced search
      </SearchTextLabelLinkStyled>
    </SearchMessageDisplayStyled>
  )
}
